import { render } from "./DatasetsListCards.vue?vue&type=template&id=cec51502&scoped=true"
import script from "./DatasetsListCards.vue?vue&type=script&lang=js"
export * from "./DatasetsListCards.vue?vue&type=script&lang=js"

import "./DatasetsListCards.vue?vue&type=style&index=0&id=cec51502&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cec51502"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
